import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityApplicationOverviewSlice } from './get';

export const coreDataSecurityApplicationOverviewReducers = combineReducers({
	get: getCoreDataSecurityApplicationOverviewSlice.asyncReducers
});

export const coreDataSecurityApplicationOverviewWatchers = combineAllWatchers([
	getCoreDataSecurityApplicationOverviewSlice.asyncWatchers
]);
